export default __webpack_public_path__ + "db9a90e783cd1816a4218981fe46eecd.png";